import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from "../images/download-doc.svg";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import Typography from "@mui/material/Typography";
import {IconButton} from "@mui/material";
import moment from "moment-timezone";
import {withTranslation} from "react-i18next";
import { ReportToolbar } from "../ReportPageLayout";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  PHARMACY_REPORT_SORT_MAP,
} from "../../grid/iLocalAGGrid";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      {
        id: "given_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.FirstName"),
        padding: "10px",
        field: "given_name",
      },
      {
        id: "family_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.LastName"),
        padding: "10px",
        field: "family_name",
      },
      {
        id: "external_id",
        numeric: false,
        disablePadding: false,
        label: t("Report.HLOrderStaging.ExternalId"),
        padding: "10px",
        field: "external_id",
      },
      {
        id: "internal_id",
        numeric: false,
        disablePadding: false,
        label: t("Report.HLOrderStaging.InternalId"),
        padding: "10px",
        field: "internal_id",
      },
      {
        id: "dob",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DOB"),
        padding: "10px",
        field: "dob",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.Email"),
        padding: "10px",
        field: "email",
      },
      {
        id: "phone",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.Phone"),
        padding: "10px",
        field: "sms_phone",
      },
      {
        id: "prescription_number",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.PrescriptionNumber"),
        padding: "10px",
        field: "prescription_number",
      },
      {
        id: "text_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DrugName"),
        padding: "10px",
        field: "drug_name",
      },
      {
        id: "dispense_amount",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.AmountDue"),
        padding: "10px",
        field: "dispense_amount",
      },
      {
        id: "quantity",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DispensedQty"),
        padding: "10px",
        field: "quantity",
      },
      {
        id: "end_date",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.ExpiryDate"),
        padding: "10px",
        field: "end_date",
      },
      {
        id: "created_on",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.OrderTimestamp"),
        padding: "10px",
        field: "created_on",
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: "rgba(0, 0, 0, 0.54)" }}>
                {[
                  "external_id",
                  "internal_id",
                  "email",
                  "phone",
                  "quantity",
                  "dispense_amount",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}>
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  dob: {
    paddingTop: "25px",
  },
  headerdiv: {
    paddingLeft: "15%",
    paddingTop: "10",
  },
  padding10px: {
    padding: "10px",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: "absolute",
    width: "89%",
    height: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255,255,255,0.5)",
    zIndex: "7869",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
  rowheight: {
    height: "35px",
  },
});

const __reportDefaultDates = getDefaultDateRange();

let OrderViewFilterObj = {
  searchObject: null,
  searchtext: "",
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class HLOrdersView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: "",
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: "",
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      selectedTab: 0,
      tempThresholds: [],
      totalRecords: 0,
      locale: localStorage.getItem("i18nextLng") === "en" ? enLocale : frLocale,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && OrderViewFilterObj.pageSize !== newPageSize) {
      OrderViewFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      sortMap: PHARMACY_REPORT_SORT_MAP,
      filterBody: OrderViewFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['created_on'] });
      },
      pageZeroBased: true,
      getPageSize: () => OrderViewFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "hl/orders/list", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, OrderViewFilterObj, 'created_on');
  };

  componentDidMount() {
    OrderViewFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(OrderViewFilterObj, {
      searchtext: "",
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: "desc",
      sortColumn: "created_on",
      tableName: ""});
    this.fetchSuggestions();
    this.setState({ loader: false });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("MM/DD/YYYY hh:mm:ss A")
      : date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("DD/MM/YYYY hh:mm:ss A");
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (
      [
        "order_status",
        "external_id",
        "internal_id",
        "family_name",
        "given_name",
        "middle_name",
        "dob",
        "alternate_dob",
        "end_date",
        "text_name",
        "given_doses_form",
        "dispense_amount",
        "dispense_units",
        "prescription_number",
        "phone",
        "created_on",
      ].includes(field)
    ) {
      tablename = "hl_order_staging";
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    OrderViewFilterObj.sortOrder = order;
    OrderViewFilterObj.sortColumn = field;
    OrderViewFilterObj.tableName = this.gettingOnSortTableName(orderBy);

    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();

    OrderViewFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {

    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000);
  };

  onFromDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  onToDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;

    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });

    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    OrderViewFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

  getPhoneNumber = (phoneString) => {
    if (![undefined, undefined, null, null, ""].includes(phoneString)) {
      return this.cleanPhoneNumber(phoneString);
    } else {
      return null;
    }
  };

  cleanPhoneNumber(phoneNumber) {
    return phoneNumber ? phoneNumber.replace(/[()\s-]/g, '') : phoneNumber;
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    OrderViewFilterObj.group_id = event.target.value;
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, t} = this.props;
    return (
      <Paper id="react-no-print" className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <ReportToolbar>
          <Tooltip
            key="single-edit"
            title={t("Report.OrderStaging.ExportCSVTooltip")}>
            <IconButton
              style={{ marginRight: "0" }}
              aria-label="ExportCSV">
              <img
                alt="download"
                onClick={() => {
                this.exportCSV();
                }}
                src={download}
                style={{
                height: "32px",
                width: "32px",
                cursor: "pointer",
                }}
                />
              </IconButton>
            </Tooltip>
        </ReportToolbar>

        <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'given_name', headerName: t("Report.OrderStaging.FirstName"), colId: 'given_name' },
              { field: 'family_name', headerName: t("Report.OrderStaging.LastName"), colId: 'family_name' },
              { field: 'external_id', headerName: t("Report.HLOrderStaging.ExternalId"), colId: 'external_id' },
              { field: 'internal_id', headerName: t("Report.HLOrderStaging.InternalId"), colId: 'internal_id' },
              { field: 'dob', headerName: t("Report.OrderStaging.DOB"), colId: 'dob', valueGetter: (p) => [undefined,'undefined',null,'null',''].includes(p.data && p.data.dob) ? (p.data && p.data.alternate_dob) : (p.data && p.data.dob) },
              { field: 'email', headerName: t("Report.OrderStaging.Email"), colId: 'email' },
              { field: 'phone', headerName: t("Report.OrderStaging.Phone"), colId: 'phone', valueGetter: (p) => this.getPhoneNumber(p.data && p.data.phone) },
              { field: 'prescription_number', headerName: t("Report.OrderStaging.PrescriptionNumber"), colId: 'prescription_number' },
              { field: 'text_name', headerName: t("Report.OrderStaging.DrugName"), colId: 'text_name' },
              { field: 'dispense_amount', headerName: t("Report.OrderStaging.AmountDue"), colId: 'dispense_amount', valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'quantity', headerName: t("Report.OrderStaging.DispensedQty"), colId: 'quantity' },
              { field: 'end_date', headerName: t("Report.OrderStaging.ExpiryDate"), colId: 'end_date' },
              withDateColumnFilter({ field: 'created_on', headerName: t("Report.OrderStaging.OrderTimestamp"), colId: 'created_on', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={OrderViewFilterObj.pageSize || 10}
            paginationPageSize={OrderViewFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
      </Paper>
    );
  }
}

HLOrdersView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(HLOrdersView)
);



// WEBPACK FOOTER //
// ./src/components/reports/hl_orders_view/index.js